export function parseLabelId(labelId: string) {
    if (!labelId) return '';
    return labelId.slice(-4)
}